module.exports = __webpack_public_path__ + "static/media/GuestList.351481ee.svg";